import { FormField } from "../form-field/FormField";
import { CheckboxField } from "~/components";
import cn from "classnames";
import { useAcceptPolitics } from "./AcceptPoliticsContext";
import styles from "./AcceptPolitics.module.scss";
import { URL_OFERTA_PARTNERS } from "~/configs/consts";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { postToggleOfferCheckbox } from "~/pages/questionnaires/v2/customer/api/apiMethods";
import { reactNodeToText } from "./reactNodeToText";

const partnerAcceptPoliticsTitle = (
  <p className={styles.text}>
    Я ознакомлен(а) и согласен(на) в полном объеме с условиями предоставления услуг, положениями{" "}
    <a href={URL_OFERTA_PARTNERS} target="_blank" className={styles.textBlueLink} rel="noopener noreferrer">
      Оферты
    </a>{" "}
    и принимаю их. Я подтверждаю достоверность введенных данных.
  </p>
);

const PartnerAcceptPromoTitle = () => (
  <p className={styles.text}>
    Я даю{" "}
    <a
      href="https://prodamus.ru/soglasie-personalnye-dannye-i-consenttomailings"
      target="_blank"
      className={styles.textBlueLink}
      rel="noopener noreferrer"
    >
      согласие
    </a>{" "}
    на получение рекламно-информационной рассылки и обработку персональных данных.
  </p>
);

interface Props {
  containerClassName?: string;
}

export const PartnerAcceptPolitics = ({ containerClassName }: Props) => {
  const {
    isAcceptPolitics, setIsAcceptPolitics, acceptPoliticsError, setAcceptPoliticsError,
    isAcceptPromo, setIsAcceptPromo, acceptPromoError, setAcceptPromoError,
    isPendingOffer, setIsPendingOffer,
    clientId,
  } = useAcceptPolitics();

  const handleAcceptPoliticsChange = async (val: boolean) => {
    if (val) setAcceptPoliticsError(null);
    setIsAcceptPolitics(val);

    if (!clientId) return;

    setIsPendingOffer(true);
    try {
      const checkboxText = reactNodeToText(partnerAcceptPoliticsTitle);

      if (val) {
        await postToggleOfferCheckbox([
          {
            questionnaire_uid: clientId,
            offer_url: URL_OFERTA_PARTNERS,
            action: "check" as const,
            website_address: window.location.href,
            checkbox_text: checkboxText,
          },
        ]);
      } else {
        await postToggleOfferCheckbox([
          { questionnaire_uid: clientId, offer_url: URL_OFERTA_PARTNERS, action: "uncheck" as const },
        ]);
      }
    } catch {
    } finally {
      setIsPendingOffer(false);
    }
  };

  return (
    <div className={cn(styles.container, containerClassName)}>
      <FormField name="accept-politics" renderError={acceptPoliticsError}>
        <div style={{ position: "relative", pointerEvents: isPendingOffer ? "none" : "auto" }}>
          {isPendingOffer && (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 16, color: "#3d935e" }} spin />}
              style={{ position: "absolute", left: 0, top: 10, zIndex: 1 }}
            />
          )}
          <CheckboxField
            fieldName="accept-politics"
            checked={isAcceptPolitics}
            title={partnerAcceptPoliticsTitle}
            styleIndicatorProps={{ top: 4, visibility: isPendingOffer ? "hidden" : undefined }}
            onChange={handleAcceptPoliticsChange}
            disabled={isPendingOffer}
          />
        </div>
      </FormField>

      <FormField name="accept_promo" renderError={acceptPromoError}>
        <CheckboxField
          fieldName="accept_promo"
          checked={isAcceptPromo}
          title={<PartnerAcceptPromoTitle />}
          styleIndicatorProps={{ top: 4 }}
          onChange={(val: boolean) => {
            if (!isAcceptPromo) setAcceptPromoError(null);
            setIsAcceptPromo(val);
          }}
        />
      </FormField>
    </div>
  );
};
